import React from 'react';
import {WerfenColor, White} from '../../Constants/ColorChart';
import {connect} from 'react-redux';
import FeatherIconWrapper from "../Icons/FeatherIconWrapper";
import AvailableOfflineIcon from '../Icons/AvailableOffline/AvailableOffline';
import UnavailableOfflineIcon from '../Icons/AvailableOffline/UnavailableOffline';
import "./AvailableOfflineIndicator.css";
import {DownloadState} from "../../../Download/Reducer/Download";
import DocumentDownload from "../../../Download/Entity/DocumentDownload";

type AvailableOfflineIndicatorProps = {
    color: string;
    fillColor: string;
    width: string;
    activeStyle: string;
    unactiveStyle: string;
    isGlobalIndicator: boolean;
    isDownloading: boolean;
    isActive: boolean;
    onClick: () => void;
}

const AvailableOfflineIndicator = (props: AvailableOfflineIndicatorProps & mapStateToPropsType) => {
    const {
        color,
        fillColor,
        width,
        activeStyle,
        unactiveStyle,
        isGlobalIndicator,
        isDownloading,
        isActive,
        currentDownload
    } = props;

    const isWorkingOnDownloadProcess: boolean = null !== currentDownload;
    const isItGlobalIndicator: boolean = isGlobalIndicator && isWorkingOnDownloadProcess;
    const isItDownloading: boolean = isDownloading && isWorkingOnDownloadProcess;

    const isItBlinking = isItGlobalIndicator || isItDownloading;

    const iconStyle = () => {
        if (isItGlobalIndicator) {
            return `${activeStyle} stroke: ${White}`
        }
        if (isItDownloading) {
            return `${unactiveStyle}; fill: ${WerfenColor}; stroke: ${White}`
        }
        return isActive ? activeStyle : unactiveStyle
    }
    const clickAction = () => {
        props.onClick();
    }

    return (
        <FeatherIconWrapper
            color={color}
            fillColor={fillColor}
            width={width}
            className={isItBlinking ? "blink" : ""}
            iconStyle={iconStyle}
            Icon={isActive ? AvailableOfflineIcon : UnavailableOfflineIcon}
            onClick={() => !isActive && clickAction()}
            fillSecondaryColor={null}
            isActive={true}
            ariaLabel={isActive ? "Available Offline" : "Unavailable Offline"}
            role={null}
        />
    )
}

type AvailableOfflineIndicatorStageProps = {
    download: DownloadState
}

type mapStateToPropsType = {
    documents: DocumentDownload[],
    currentDownload: DocumentDownload | null
}

const mapStateToProps = (state: AvailableOfflineIndicatorStageProps): mapStateToPropsType => ({
    documents: state.download.download,
    currentDownload: state.download.currentDownload
});

export default connect(mapStateToProps, {})(AvailableOfflineIndicator);